import { FaChevronDown } from 'react-icons/fa'
import Parcelle from 'entity/Parcelle'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { Button } from 'react-bootstrap'
import { toggleDetail } from 'redux/features/parcelle/slice'
import {
  makeSelectSelectedParcelleMoreInformationIndex,
  makeSelectParcelles,
} from 'redux/features/parcelle/selectors'
import pluralizer from 'utils/pluralizer'
import cn from 'classnames'
import { useMemo } from 'react'
import s from '../Information.module.scss'

interface Props {
  parcelle: Parcelle
}

const InformationMulti = ({ parcelle }: Props): JSX.Element => {
  const parcelles = useAppSelector(makeSelectParcelles)
  const selectedParcelleMoreInformationIndex = useAppSelector(
    makeSelectSelectedParcelleMoreInformationIndex
  )
  const { batiList, uid, historique } = parcelle
  const dispatch = useAppDispatch()

  const phraseResume = useMemo<string>(() => {
    if (batiList.length === 0 && historique.length > 0) {
      return `${historique.length}
        ${pluralizer('historique', historique.length)} de vente`
    }
    if (batiList.length > 0 && historique.length === 0) {
      return `${batiList.length}
        ${pluralizer('bâti', batiList.length)} et pas d'historique de vente`
    }
    return `${batiList.length}
        ${pluralizer('bâti', batiList.length)} et
        ${historique.length} ${pluralizer('historique', historique.length)}
        de vente`
  }, [historique, batiList])

  return (
    <Button
      className={cn({
        [s.active]:
          selectedParcelleMoreInformationIndex !== null &&
          parcelle.uid === parcelles[selectedParcelleMoreInformationIndex].uid,
      })}
      variant="link"
      onClick={() => dispatch(toggleDetail(uid))}
    >
      <span>{phraseResume}</span>
      <FaChevronDown />
    </Button>
  )
}

export default InformationMulti
